import { FC } from 'react';

import { CAMPAIGNS_DASHBOARD_PAGE_ROUTE } from 'utils/constants/app';
import { SPACE } from 'utils/constants/common';

import useTrls from 'hooks/translation/useTrls';

import { Banners } from 'components/Banners/Banners';
import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { Header } from 'components/Header/Header';

import { useSelector } from 'store/utils';

const TrlKeys = {
    advertisements: 'BannersPage.breadcrumbs.advertisements',
    banners: 'BannersPage.title',
};

export const BannersPage: FC = () => {
    const trls = useTrls();
    const campaignTitle = useSelector((state) => state.banners.campaign?.title);

    return (
        <>
            <Header />
            <PageContentHeader
                breadcrumbsConfig={[
                    {
                        to: CAMPAIGNS_DASHBOARD_PAGE_ROUTE,
                        children: trls(TrlKeys.advertisements),
                    },
                    {
                        to: '#',
                        children: trls(TrlKeys.banners),
                    },
                ]}
                title={`${trls(TrlKeys.banners)}${SPACE}${campaignTitle ?? ''}`}
                vSpacingBottom={24}
            />
            <Banners />
        </>
    );
};
